import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import React, { useState, useRef, useEffect } from 'react';
import '../../../Modal/styleModal.css';
import { loadFobImagesFromServer, uploadFobImage, deleteFobImage } from '../../../FileResources/FobFoto/ServiceUtilitiesFobFoto';

const DialogFobFotoEditing = ({open, onClose, id, user}) => {
 
  const fileInputRef = useRef(null);
  const [fileName, setFileName] = useState('');
  const [isFileUploaded, setIsFileUploaded] = useState(false);
  const [uploadMessage, setUploadMessage] = useState('');
  const [serverImageUrls, setServerImageUrls] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);

  // Открытие модального окна для изображения
  const handleImageClick = (url) => {
    setSelectedImage(url);
  };

  // Закрытие модального окна
  const closeModal = () => {
    setSelectedImage(null);
  };

  // Обработка выбора файла
  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  // Обработка загрузки файла
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      await uploadFobImage(file, id, setFileName, setIsFileUploaded, setServerImageUrls, setUploadMessage, user);
    }
  };

  // Обработка удаления изображения
  const handleDelete = async (fileName) => {
    await deleteFobImage(fileName, id, setServerImageUrls, setUploadMessage);
  };

  // Загружать изображения при старте страницы
  useEffect(() => {
    loadFobImagesFromServer(id, setServerImageUrls, setUploadMessage);
  }, []); // Пустой массив зависимостей, чтобы загрузка выполнялась только при монтировании

 
  
    return (
      <Dialog open={open} className="modalStyleFoto" fullWidth maxWidth="md"> 
      <DialogContent>
        <div className='divFotoRes' style={{ width: '100%', height: '100%', paddingRight: '10px' }}>
          
            <div style={{ height: '100%' }}> 
              
              <label style={{ color: '#dfab01', fontSize: '20px', fontFamily:'unset'}}>Редактирование файлов</label>
              <br/>
              <button className='buttonIsHideModal' style={{width: '150px'}} onClick={handleButtonClick}>
        Загрузить фото
      </button>
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={handleFileChange}
        accept="image/*"
      />
      {isFileUploaded && (
        <div>
           <label style={{ color: '#fad46b', fontWeight: 'bold'}}>Имя файла: <span style={{ color: '#bebebe',fontWeight: 'normal' }}>{fileName}</span> </label>
           <br/>
           <label style={{ color: '#92ab87',fontWeight: 'normal' }}>Файл загружен</label>
        </div>
      )}
              <hr className='horizontalLineDialog'/>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr', 
                  gap: '10px', 
                   width: '100%',
                  height: '100%',
                  overflowY: 'auto', 
                  

                }}
              >
                {serverImageUrls.map((image, index) => (
                  <div key={index} style={{ marginTop: '10px' }}>
                    <img
                      src={image.url}
                      alt={`Изображение с сервера ${index}`}
                      style={{ maxWidth: '100%', height: 'auto', cursor: 'pointer' }}
                      onClick={() => handleImageClick(image.url)}
                    />
                    <button className='buttonIsDeleteModal' onClick={() => handleDelete(image.fileName)}>Удалить</button>
                  </div>
                ))}
              </div>
            </div>
         
          {/* {uploadMessage && <p>{uploadMessage}</p>} */}
      
      {/* Модальное окно для просмотра изображения */}
      {selectedImage && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000
          }}
          onClick={closeModal} 
        >
          <img
            src={selectedImage}
            alt="Полноразмерное изображение"
            style={{ maxWidth: '90%', maxHeight: '90%' }}
          />
        </div>
      )}
    </div>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} class='buttonIsHideModal'>
          Закрыть
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DialogFobFotoEditing;